import { render, staticRenderFns } from "./Overpacks.vue?vue&type=template&id=dceb2f2c&scoped=true&"
import script from "./Overpacks.vue?vue&type=script&lang=js&"
export * from "./Overpacks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dceb2f2c",
  null
  
)

export default component.exports